import React, { Component } from 'react';
//import OriginUpload from 'bee-upload';

import { Upload as OriginUpload } from '@tinper/next-ui';

import { isFunction, gzip as Gzip, getAppReqParam, getCookie, getGlobalStorage, getTopWindow, encryptFormData, decryptFormData } from '@platform/api';

import { Cipher } from '@platform/api';
import Loading from '../Loading';

//require('bee-upload/build/Upload.css');
require('./index.less');

// 由于是从api中导出
const CipherControl = Cipher.default;

let sendChildDate = null; //chendc修改，为了导入的时候使用此参数与进度同步
let cckk = (top && getTopWindow().cookiets) || getCookie('cookiets') || Date.now(); //双cookie验证 liuxis
// 做一次 数据转型
cckk = isNaN(cckk) ? cckk : Number(cckk);
// 加密 bbqin
//let cipherFlag = getGlobalStorage('localStorage', 'rockin');
let NCC_SYS_Switch = JSON.parse(localStorage.getItem('NCC_SYS_Switch')) || {};
let cipherFlag = NCC_SYS_Switch.aesKey;

// 将是否加密缓存到组件单例上
CipherControl.CipherFlag = cipherFlag;

// 处理系统变量
function getSysterm() {
    // 从ajax哪里取得，目的获取busiaction
    let { app, appcode } = getAppReqParam();

    let busiaction = `${app || null}-${window.actionName || null}`;
    //chendc修改 上传点击触发setState会导致时间重置，进度标记不再统一
    sendChildDate = sendChildDate || String(new Date().getTime());

    let sysParamJson = {
        sys_busiaction: busiaction,
        sys_appcode: appcode,
        sys_ts: sendChildDate,
    };

    return sysParamJson;
}

function decrptyResponse(response, headers) {
    let cckks = headers ? String(headers['crux']) : String(cckk);
    return decryptFormData(response, cckks);
}

/**
 * @namespace Upload
 */
/**
 * Upload组件的参数描述
 * @memberof Upload
 * @component Upload
 * @property {string} accept - 接受上传的文件类型, 详见 {@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#accept| input accept Attribute}
 * @property {string} [name=file]  - 发到后台的文件参数名
 * @property {array<object>} defaultFileList  - 默认已上传的文件列表
 * @property {array<object>} fileList  - 已上传的文件列表,多用于onChange事件里
 * @property {string} action  - 上传的服务器地址
 * @property {object|function(file): object} data  - 上传所需参数或返回上传参数的方法
 * @property {number} [size=1024000]  - 上传文件的大小限制单位是byte
 * @property {object} headers  - 设置请求的头部信息 兼容ie10以上
 * @property {boolean} [multiple=false]  - 是否支持多文件上传 兼容ie10以上
 * @property {boolean} [mergeFiles=false]  - 是否合并上传文件数组
 * @property {function(file, fileList): boolean|Promise} beforeUpload  - 上传文件之前的钩子，参数为上传的文件，若返回 false 则停止上传。支持返回一个 Promise 对象，Promise 对象 reject 时则停止上传，resolve 时开始上传（ resolve 传入 File 或 Blob 对象则上传 resolve 传入对象）。注意：IE9 不支持该方法。
 * @property {function} customRequest  - 通过覆盖默认的上传行为，可以自定义自己的上传实现
 * @property {function(file): void} onChange  - 当上传状态改变之后执行的回调函数
 * @property {function(file): void} onComplete  - 当上传状态变为完成之后执行的回调函数
 * @property {function(file, object<sendChildDate>): void} NcUploadOnChange  - 当上传状态改变之后执行的回调函数 Upload 组件特有，添加了sendChildDate 来处理进度同步
 * @property {string} [listType=text]  - 内置的样式，支持text和picture
 * @property {function(file): boolean|Promise} onRemove  - 点击移除文件时的回调，返回值为 false 时不移除。支持返回一个 Promise 对象，Promise 对象 resolve(false) 或 reject 时不移除。
 * @property {boolean} [supportServerRender=false]  - 服务端渲染时需要打开这个
 * @property {boolean} [disabled=false]  - 是否禁用，设置为 true 后前端禁止删除已上传文件
 * @property {boolean} [withCredentials=false]  - 上传请求时是否携带 cookie
 * @property {string} removeText  - 移除文件的文本
 * @property {function} enterDragger  - 拖拽上传，当鼠标拖拽文件进入 Dragger 区域时触发
 * @property {function} leaveDragger  - 拖拽上传，当鼠标拖拽文件离开 Dragger 区域时触发
 * @property {function} onPreview  - 点击文件链接或预览图标时的回调
 * @property {function} onDownload  - 点击下载文件时的回调，如果没有指定，则默认跳转到文件 url 对应的标签页
 * @property {string} downloadText  - 下载文件的文本
 * @property {object | null} progress  - 自定义进度条样式(参照progress组件type为line时的参数，把相应的属性及值组合成数组), 可以设置为null，当值为null时上传时不显示进度条(注：4.4.6版本添加值为null的功能)
 * @property {boolean} [directory=false]  - 支持上传文件夹
 * @property {string} fieldid  - 自动化测试专用属性
 * @property {string} uploadClassName  - 点击或拖拽操作区div层自定义className
 * @property {number} maxCount  - 限制上传数量。当为 1 时，始终用最新上传的文件代替当前文件
 * 
 */
export default class Upload extends Component {
    constructor(props) {
        super(props);
        this.state = { loading: false };
        this.defaultCrux = cckk || (new Date().getTime());
    }

    uploadChange = info => {
        let { file } = info;

        let {
            status, // 状态 'uploading' 'done' 'error'
            response,
        } = file;
        let { showLoading = true, headers = {} } = this.props;
        headers['crux'] = String(headers['crux'] || this.defaultCrux);

        if (status == 'uploading' && showLoading) {
            this.setState({ loading: true });
        } else if (status == 'done') {
            file.response = decrptyResponse(response, headers);
            if (this.props.onComplete) {
                this.props.onComplete(info);
            }
            if (showLoading) {
                this.setState({ loading: false });
            }
        }
        if (isFunction(this.props.NcUploadOnChange)) {
            this.props.NcUploadOnChange(info, { sendChildDate });
        }

        if (isFunction(this.props.onChange)) {
            this.props.onChange(info);
        }
        sendChildDate = null;
    };

    render() {
        let { data = {}, headers = {}, loadingProps = {} } = this.props;
        // 传递加密参数
        headers['crux'] = String(headers['crux'] || this.defaultCrux);

        //表单提交数据加密  后台需要继承朱威的公共类
        let sysParamJson = getSysterm();
        let appcode = sysParamJson.sys_appcode;
        //chendch修改，导入进度查询唯一标记
        let sys_ts_uap = sysParamJson.sys_ts;
        sysParamJson = encryptFormData(JSON.stringify(sysParamJson));

        let busiParamJson = encryptFormData(JSON.stringify({ ...data, importSign: sys_ts_uap }));

        let uploadData = {
            sysParamJson,
            sys_appcode: appcode,
            busiParamJson,
        };

        return (
            <span className='base-nc-upload' onClick={() => {
                // 执行一次，避免render没有执行导致sendChildDate没有值
                getSysterm();
            }}>
                <OriginUpload
                    {...this.props}
                    data={uploadData}
                    headers={headers}
                    onChange={this.uploadChange}
                />
                <Loading
                    show={this.state.loading}
                    fullScreen={true}
                    {...loadingProps}
                />
            </span>
        );
    }
}

class Dragger extends Component {
    constructor(props) {
        super(props);
        this.defaultCrux = cckk || (new Date().getTime());
    }

    uploadChange = info => {
        let { file = {} } = info;
        let { response } = file;
        let { onChange, headers = {} } = this.props;
        headers['crux'] = String(headers['crux'] || this.defaultCrux);

        if (response) {
            file.response = decrptyResponse(response, headers);
        }
        if (isFunction(onChange)) {
            onChange(info);
        }
    }

    render() {
        let { data = {}, headers = {} } = this.props;
        // 传递加密参数
        headers['crux'] = String(headers['crux'] || this.defaultCrux);

        //表单提交数据加密  后台需要继承朱威的公共类
        let sysParamJson = getSysterm();
        let appcode = sysParamJson.sys_appcode;
        //chendch修改，导入进度查询唯一标记
        let sys_ts_uap = sysParamJson.sys_ts;
        sysParamJson = encryptFormData(JSON.stringify(sysParamJson));

        let busiParamJson = encryptFormData(JSON.stringify({ ...data, importSign: sys_ts_uap }));

        let uploadData = {
            sysParamJson,
            sys_appcode: appcode,
            busiParamJson,
        };
        return (
            <OriginUpload.Dragger
                {...this.props}
                data={uploadData}
                headers={headers}
                onChange={this.uploadChange}
                uploadClassName="uploadHoverColor"
            />
        );
    }
}

// 添加拖拽模式
Upload.Dragger = OriginUpload.Dragger;
//渐进修改 加密后的Dragger
Upload.EncryptDragger = Dragger;
